import { render, staticRenderFns } from "./SurveyActual.vue?vue&type=template&id=f23f9bce&scoped=true&"
import script from "./SurveyActual.vue?vue&type=script&lang=js&"
export * from "./SurveyActual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23f9bce",
  null
  
)

export default component.exports